// A phone held sideways (client request, 26 October 2026): landscape and no
// taller than 32em (512px). That is every phone on its side, with or without
// the browser's toolbar (924x412, 844x390, 924x350, 844x340, 640x360), and no
// tablet: the tablet is 600px tall at its shortest, and an upright phone is
// portrait. So nothing under these queries can reach 800x1280, 1280x800 or
// 412x924. The same two queries are written out in src/index.css.
export const SIDEWAYS_MQ =
  "@media (orientation: landscape) and (max-height: 32em)"
// The small phone (640x360): below Chakra md, like the upright phone sizes.
export const SIDEWAYS_SMALL_MQ =
  "@media (orientation: landscape) and (max-height: 32em) and (max-width: 47.99em)"
// A tablet held sideways (our own change, 26 October 2026): landscape, taller
// than a phone and up to 50em (800px), so 1280x800 and 960x600, and a laptop
// of that height. Taller screens (1536x900 with the avatar card beside the
// game, and bigger) keep the one-column card. Written out in src/index.css.
export const TABLET_LANDSCAPE_MQ =
  "@media (orientation: landscape) and (min-height: 32.01em) and (max-height: 50em)"
// Every upright screen, phone or tablet: the game card is as tall as its
// content there (GameSlidePage.tsx), as on the tablet held sideways. The
// upright tablet's own card layout (portrait, 600px wide or more) is written
// out in src/index.css.
export const PORTRAIT_MQ = "@media (orientation: portrait)"
